<template>
  <div class="part-item projectBuilding">
    <p class="part-title">知识产权
    </p>
    <div class="part-content">
      <span class="content-title">软件名称：</span>
      <div
        class="content-text"
        v-if="!formInfo.intellectual_name"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.intellectual_name"
        v-html="formInfo.intellectual_name"
      ></div>
      <div class="clearfix"></div>
      <span class="content-title">是否与课程名称一致：</span>
      <div
        class="content-text"
        v-if="formInfo.intellectual_same !== '0' && formInfo.intellectual_same !== '1'"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.intellectual_same === '0' || formInfo.intellectual_same === '1'"
      >
        {{ formInfo.intellectual_same === '1' ? '是' : '否' }}
      </div>
      <div class="clearfix"></div>
      <span class="content-title">著作权人：</span>
      <div
        class="content-text"
        v-if="!formInfo.intellectual_username"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.intellectual_username"
      >
        <table class="tablePower">
          <tr
            v-for="(item, index) in formInfo.personData"
            :key="index"
          >
            <td>（{{ index + 1 }}）{{ item.name }}</td>
            <td>{{ dictPowerType[item.type] }}</td>
          </tr>
        </table>
      </div>
      <div class="clearfix"></div>
      <span class="content-title">权利范围：</span>
      <div
        class="content-text"
        v-if="!formInfo.intellectual_power"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.intellectual_power"
        v-html="formInfo.intellectual_power"
      ></div>
      <div class="clearfix"></div>
      <span class="content-title">软件著作登记号：</span>
      <div
        class="content-text"
        v-if="!formInfo.intellectual_no"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.intellectual_no"
        v-html="formInfo.intellectual_no"
      ></div>
      <div class="clearfix"></div>
      <div class="tips">如软件著作权正在申请过程中，尚未获得证书，请填写受理流水号。</div>
      <div class="clearfix"></div>
      <span class="content-title">受理流水号：</span>
      <div
        class="content-text"
        v-if="!formInfo.intellectual_serial_number"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.intellectual_serial_number"
        v-html="formInfo.intellectual_serial_number"
      ></div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'IntellectualProperty',
  props: ['expId'],
  data () {
    return {
      formInfo: {
        personData: []
      },
      dictPowerType: {
        1: '课程所属学校',
        2: '企业',
        3: '课程负责人',
        4: '学校团队成员',
        5: '企业人员',
        6: '其他'
      }
    }
  },
  methods: {
    async getInfo() {
      const url = '/allowany/experiment/' + this.expId + '/'
      await this.$http.get(url).then(async (data) => {
        this.formInfo = data
        this.formInfo.personData = data.intellectual_username ? JSON.parse(data.intellectual_username) : []
      }).catch((error) => {
        console.log(error)
      })
    }

  },
  async mounted() {
    await this.getInfo()
  }
}
</script>

<style scoped src="../../assets/css/project-manage.css"></style>

<style lang="less" scoped>
table {
  border: none;
}
</style>
